export * from './lib/customer-verification/customer-verification-dialog.component';
